module.exports = __webpack_public_path__ + "img/identify07.f43dd37e.png";